import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoggerService } from '@app/logger/logger.service';
import { UploadFileDialogComponent } from './upload-file-dialog.component';

const log = new LoggerService('UPLOAD FILE SERVICE');

@Injectable({ providedIn: 'root' })
export class UploadFileDialogService {

  private dialog = inject(MatDialog);
  dialogRef!: MatDialogRef<UploadFileDialogComponent>;

  open(config?: any): Promise<unknown> {
    this.dialogRef = this.dialog.open(UploadFileDialogComponent, {
      width:        '30vw',
      disableClose: true,
      data:         config,
    });

    return new Promise(resolve => {
      this.dialogRef.afterClosed().subscribe((result: unknown) => {
        if (result) resolve(result);
      });
    });
  }
}